<div class="hubble-logo-container" style="text-align: center; margin-top: 200px;">
  <a routerLink="/signin"><img src="https://get.hubbleapp.ai/images/hubble-logo.svg" alt="Hubble Logo" style="max-width: 300px;"></a>
  <div style="font-family: sans-serif; font-size: 14px; color: lightgrey; margin-top: 5px;">v{{ envVersion }}{{ envMode == 'production' ? '' : ' [dev]' }}</div>
  <p *ngIf="authService.isSignedIn()" style="margin-top: 100px;">
    Hello user! You are signed in as <strong>{{ authService.getUser()?.email }}</strong>. <br>
    <a routerLink="/dashboard">Go to Dashboard</a>
  </p>
</div>